<template>
  <div>
    <data-select
      :size="size"
      :title="title"
      :defaultParams="defaultParams"
      :placeholder="placeholder"
      :fieldList="fieldList"
      :paramList="paramList"
      :width="1000"
      :showMenu="true"
      :menuWidth="200"
      :listApi="
        mode == 'store'
          ? 'biz.warehouse.replenish.info.list'
          : 'biz.warehouse.replenish.info.listByStorehouse'
      "
      valuePropName="guid"
    >
      <template slot="menu" slot-scope="scope">
        <ul class="list-group">
          <a
            @click="modeClick('store')"
            :class="
              mode == 'store'
                ? 'list-group-item list-group-item-action active'
                : 'list-group-item list-group-item-action'
            "
            :aria-current="mode == 'store'"
          >
            本店补货单
          </a>
          <a
            @click="modeClick('storehouse')"
            :class="
              mode == 'storehouse'
                ? 'list-group-item list-group-item-action active'
                : 'list-group-item list-group-item-action'
            "
            :aria-current="mode == 'storehouse'"
          >
            下级门店补货单
          </a>
        </ul>
      </template>
      <template slot="row-info" slot-scope="scope">
        <warehouse-replenish-info :replenishInfo="scope.row" />
        <slot name="info-append" :info="scope.row" :cancel="scope.cancel" />
      </template>
    </data-select>
  </div>
</template>

<style lang="less" scoped>
.select-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-size: 14px;
}
.select-footer {
  margin-top: 10px;
  text-align: right;
}
</style>

<script>
import dataSelect from '../dataSelect.vue';
import warehouseReplenishInfo from './warehouseReplenishInfo.vue';

export default {
  components: {
    dataSelect,
    warehouseReplenishInfo,
  },
  props: {
    size: {
      type: String,
    },
    title: {
      type: String,
      default: "请选择",
    },
    placeholder: {
      type: String,
      default: "选择补货单",
    },
    storeGuid: {
      type: String
    },
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    defaultParams() {
      return Object.assign({
        optCancel: "0",
        storeGuid: this.storeGuid,
      }, this.params || {}, this.queryModel || {})
    }
  },
  data() {
    return {
      mode: "store",
      queryModel: {},
      fieldList: [
        {
          label: '补货单信息',
          minWidth: '320',
          slot: "info",
        },
      ],
      paramList: [
        {
          label: '查询关键词',
          field: ['queryValue'],
          styleValue: "width: 300px"
        }
      ]
    };
  },
  methods: {
    modeClick(mode) {
      this.mode = mode;
    },
  }
}
</script>